import React from 'react'

const GetSimpleOptions = ({data, keySuffux}) => {
  return <>
    <option value="">Please select</option>
    {
        data.map((d,i)=><option value={d} key={keySuffux+`_`+i}>{d}</option>)
    }
  </>
}

export default GetSimpleOptions